import { render, staticRenderFns } from "./WorkRequestSummary.vue?vue&type=template&id=fb4e37c8&scoped=true"
import script from "./WorkRequestSummary.vue?vue&type=script&lang=ts"
export * from "./WorkRequestSummary.vue?vue&type=script&lang=ts"
import style0 from "./WorkRequestSummary.vue?vue&type=style&index=0&id=fb4e37c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4e37c8",
  null
  
)

export default component.exports